import React, { useEffect, useState } from 'react';
import Navbar from '../components/layout/Navbar';
import { useLocation } from 'react-router-dom';
import config from './../config/config';
import AttendeesCard from '../components/layout/AttendeesCard';
import insertUrlParam from '../utilities/insertUrlParam';

// Source: https://gist.github.com/zentala/1e6f72438796d74531803cc3833c039c
// Usage:
// formatBytes(bytes,decimals)
// formatBytes(1024);       // 1 KB
// formatBytes('1024');     // 1 KB
// formatBytes(1234);       // 1.21 KB
// formatBytes(1234, 3);    // 1.205 KB
function prettyBytes(bytes, decimals) {
  if (parseInt(bytes) === 0) return '0 Bytes';
  var k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

async function s3List(prefix) {
  return fetch(config.apiURL + `/s3/list?prefix=${prefix}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      token: config.getToken()
    }
  }).then((data) => data.json());
}

async function s3DownloadURL(key) {
  return fetch(config.apiURL + `/s3/download?key=${key}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      token: config.getToken()
    }
  }).then((data) => data.json());
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const makeBaseState = () => {
  return [
    {
      id: 0,
      fileName: 'outreach',
      size: '',
      filePath: 'outreach/',
      type: '',
      isdir: true,
      modified: '0001-01-01T00:00:00Z',
      modifiedBy: ''
    }
  ];
};

export default function FileExplorer() {
  const basePrefix = useQuery().get('s3_prefix') || '';

  const [results, setResults] = useState(makeBaseState());
  // eslint-disable-next-line no-unused-vars
  const [prefix, setPrefix] = useState(
    basePrefix.startsWith('outreach') ? basePrefix : ''
  );

  const [isLoaded, setIsLoaded] = useState(false);

  const handleS3Download = async (key) => {
    let newWindow = window.open('', '_blank');
    const downloadURL = await s3DownloadURL(key);
    newWindow.location.href = downloadURL;
  };

  useEffect(() => {
    async function getData() {
      if (prefix && prefix.startsWith('outreach')) {
        let results = await s3List(prefix);
        setResults(results);
        setIsLoaded(true);
      } else {
        setIsLoaded(true);
      }
    }
    getData();
  }, [prefix]);

  const createTable = (r) => {
    let d = new Date(r.modified);

    if (!r.isdir) {
      return (
        <tr key={r.id}>
          <td>{r.id}</td>
          <td>{r.fileName}</td>
          <td>{prettyBytes(r.size)}</td>
          <td>{d.toLocaleString()}</td>
          <td>
            <button
              className='like-anchor'
              onClick={() => {
                handleS3Download(`${r.filePath}/${r.fileName}`);
              }}
            >
              Download
            </button>
          </td>
        </tr>
      );
    } else {
      return (
        <tr key={r.id}>
          <td>{r.id}</td>
          <td>
            <button
              className='like-anchor'
              onClick={() => {
                insertUrlParam('s3_prefix', r.filePath);
                window.location = window.location.href;
              }}
            >
              {r.fileName}
            </button>
          </td>
          <td> -- </td>
          <td>{d.toLocaleString()}</td>
          <td> -- </td>
        </tr>
      );
    }
  };

  if (!isLoaded) {
    return (
      <div>
        <Navbar />
        <br />
        <center>
          <p>Loading... Please wait.</p>
        </center>
      </div>
    );
  } else {
    return (
      <div>
        <Navbar />
        <br />
        <h2>File Explorer</h2>
        <br />
        <center>
          {/* <h3>Current Path: {makePath()}</h3> */}
          {/* <h3>Email or Meetings tables</h3> */}
          <table style={{ width: '85%', textAlign: 'center' }}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Size</th>
                <th>Last Modified</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>{results.map(createTable)}</tbody>
          </table>
        </center>
        <br />
        <br />
        <br />
        <AttendeesCard
          prefix={prefix}
          cardType={
            prefix.includes('meetings')
              ? 'meeting'
              : prefix.includes('emails')
              ? 'email'
              : undefined
          }
        />
      </div>
    );
  }
}
